import React, { useState, useEffect } from 'react';
import Footer from '../components/Footer';
import Navbar from '../components/Navbar';
import Heroimage3 from '../components/Heroimage3';
import Work from '../components/Work';

const About = () => {
  const [heading, setHeading] = useState('');
  const [isTyping, setIsTyping] = useState(true);
  const aboutHeading = 'ABOUT US';

  useEffect(() => {
    let letterIndex = 0;

    const typingInterval = setInterval(() => {
      if (!isTyping) return;

      setHeading(aboutHeading.substring(0, letterIndex));

      if (letterIndex === aboutHeading.length) {
        setIsTyping(false);
        clearInterval(typingInterval);
      } else {
        letterIndex++;
      }
    }, 100);

    return () => clearInterval(typingInterval);
  }, [isTyping, aboutHeading]);

  return (
    <div>
      <Navbar />
      <Heroimage3 heading={heading} text={<p>Knora Tec is a technology company specializing in machine learning integrated biomedical products for healthcare. With expertise in web development, data analysis, and marketing strategy, their team delivers innovative solutions to improve patient outcomes and drive industry transformation.</p>} />
      <Work />
      <Footer />
    </div>
  );
};

export default About;

//https://www.google.com/maps/place/Knora+Tec/@13.0109834,80.0702424,12z/data=!4m20!1m13!4m12!1m4!2m2!1d80.131692!2d12.9288755!4e1!1m6!1m2!1s0x3a5265156b12cb2b:0xcacd935c3a468302!2sknora+tec!2m2!1d80.2061091!2d13.1086185!3m5!1s0x3a5265156b12cb2b:0xcacd935c3a468302!8m2!3d13.1086185!4d80.2061091!16s%2Fg%2F11kqc4907b?entry=ttu